import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination, Empty } from "antd";

import MeetingTopPart from "./meeting-top-part";

import { MeetingAction } from "../../store/actions";

import { meeting, Loader, boxContainer, Spacer } from "../../components";

function UpcomingMeetings() {
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);

  const { upcomingMeetings, upcomingMeetingsCount, isUpcomingMeetingsLoading } =
    useSelector((state) => state.meeting);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    fetchMeeting();
  }, [pageNo, profileData]);

  const fetchMeeting = () => {
    const meetingPayload = {
      limit,
      offset,
    };
    dispatch(MeetingAction.getUpcomingMeetings(meetingPayload));
    dispatch(MeetingAction.getAllMeetingsAndCount());
  };

  const handlePagination = (pagenumber) => {
    setOffset((pagenumber - 1) * limit);
    setPageNo(pagenumber);
  };

  return (
    <div className="text-black">
      <boxContainer.LiteBoxContainer>
        <MeetingTopPart />
        <Spacer height={20} />
        <div>
          {isUpcomingMeetingsLoading ? (
            <Loader.Circular />
          ) : upcomingMeetingsCount === 0 ? (
            <div className="p-6">
              <Empty />
            </div>
          ) : (
            <>
              {upcomingMeetings?.map((item, index) => (
                <meeting.MeetingRow item={item} index={index} key={index} />
              ))}
              <div className="flex justify-center items-center p-3">
                <Pagination
                  responsive="true"
                  showSizeChanger={false}
                  hideOnSinglePage={false}
                  current={pageNo}
                  pageSize={limit}
                  total={upcomingMeetingsCount}
                  onChange={handlePagination}
                />
              </div>
            </>
          )}
        </div>
      </boxContainer.LiteBoxContainer>
    </div>
  );
}
export default UpcomingMeetings;
